// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function spaceRoleGQLFields(fields) {
    return `
    id
    name
    type
    description
  `;
}
//# sourceMappingURL=spaceRole.fields.js.map